import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFxShowHandsetLandscapeDirective } from './directive/custom-fx-show-handset-landscape.directive';
import { CustomFxBreakpointsProvider } from './provider/custom-fx-breakpoints.provider';
import { CustomFxShowHandsetPortraitDirective } from './directive/custom-fx-show-handset-portrait.directive';
import { CustomFxShowTabletPortraitDirective } from './directive/custom-fx-show-tablet-portrait.directive';
import { CustomFxShowTabletLandscapeDirective } from './directive/custom-fx-show-tablet-landscape.directive';
import { CustomFxHideTabletLandscapeDirective } from './directive/custom-fx-hide-tablet-landscape.directive';
import { CustomFxHideTabletPortraitDirective } from './directive/custom-fx-hide-tablet-portrait.directive';
import { CustomFxHideHandsetPortraitDirective } from './directive/custom-fx-hide-handset-portrait.directive';
import { CustomFxHideHandsetLandscapeDirective } from './directive/custom-fx-hide-handset-landscape.directive';
import { CustomFxFlexHandsetLandscapeDirective } from './directive/custom-fx-flex-handset-landscape.directive';
import { CustomFxLayoutHandsetLandscapeDirective } from './directive/custom-fx-layout-handset-landscape.directive';
import { CustomFxFlexOrderHandsetLandscapeDirective } from './directive/custom-fx-flex-order-handset-landscape.directive';

@NgModule({
  declarations: [
    CustomFxShowHandsetLandscapeDirective,
    CustomFxShowHandsetPortraitDirective,
    CustomFxShowTabletPortraitDirective,
    CustomFxShowTabletLandscapeDirective,
    CustomFxHideTabletLandscapeDirective,
    CustomFxHideTabletPortraitDirective,
    CustomFxHideHandsetPortraitDirective,
    CustomFxHideHandsetLandscapeDirective,
    CustomFxFlexHandsetLandscapeDirective,
    CustomFxLayoutHandsetLandscapeDirective,
    CustomFxFlexOrderHandsetLandscapeDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CustomFxShowHandsetLandscapeDirective,
    CustomFxShowHandsetPortraitDirective,
    CustomFxShowTabletPortraitDirective,
    CustomFxShowTabletLandscapeDirective,
    CustomFxHideTabletLandscapeDirective,
    CustomFxHideTabletPortraitDirective,
    CustomFxHideHandsetPortraitDirective,
    CustomFxHideHandsetLandscapeDirective,
    CustomFxFlexHandsetLandscapeDirective,
    CustomFxLayoutHandsetLandscapeDirective,
    CustomFxFlexOrderHandsetLandscapeDirective
  ],
  providers: [
    CustomFxBreakpointsProvider
  ]
})
export class CustomFxModule { }
